<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/admin"></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button size="large" (click)="AddNew()"><ion-icon slot="icon-only" name="add-outline"
          style="font-size: 38px"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title>Recipes</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <ion-grid *ngIf="!isLoading">
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-segment value="dogs" [(ngModel)]="filter" (ionChange)="filterRecipes()">
          <ion-segment-button value="dogs">
            <ion-label>
              Dogs
            </ion-label>
          </ion-segment-button>
          <ion-segment-button value="cats">
            <ion-label>
              Cats
            </ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="ion-text-center ion-padding" *ngIf="!isLoading && loadedRecipes.length===0">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-img src="../../../assets/images/MimboLogo.png" class="logo"></ion-img>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-text color="darkmimbo">You have not added any recipes yet. <br />
    </ion-text>
  </div>
  <ion-list *ngIf="!isLoading && loadedRecipes">
    <ion-grid>
      <ion-row>
        <ion-col sizeXl="10" offsetXl="1">
          <ion-list>
            <ion-item-sliding *ngFor="let recipe of loadedRecipes">
              <ion-item detail button="true" color="lightmimbo" (click)="ViewRecipe(recipe.id)">
                <img [src]="recipe.image" class="avatar" />
                <div style="padding-bottom: 12px; padding-top: 12px">
                  <h1 class="ion-padding-top ion-padding-bottom">
                    {{recipe.name}}<br />
                    <span class="type">{{recipe.type}}</span>
                  </h1>
                </div>
              </ion-item>
              <ion-item-options>
                <ion-item-option color="danger" (click)="deleteRecipe(recipe.id)"><ion-icon name="trash-outline"
                    slot="start"></ion-icon>Delete</ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-list>
</ion-content>

<ion-modal class="full-ion-modal" [isOpen]="isModalOpen" #recipeModal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()"><ion-icon name="arrow-back-outline" slot="icon-only"> </ion-icon></ion-button>
        </ion-buttons>
        <ion-title>Add/Update Recipe</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" color="lightmimbo" *ngIf="isPreviewMode == false">
      <form #f="ngForm" class="ion-padding" (ngSubmit)="previewRecipe()">
        <ion-grid>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Name" required [(ngModel)]="selectedName" name="nameCtrl" labelPlacement="floating"
                  placeholder="Enter Recipe Name"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-select required name="petTypeCtrl" label="Pet Type*" labelPlacement="floating"
                  interface="action-sheet" [(ngModel)]="petTypeId">
                  <ion-select-option [value]="1">Dogs</ion-select-option>
                  <ion-select-option [value]="2">Cats</ion-select-option>
                </ion-select>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Recipe Type" required [(ngModel)]="selectedType" name="typeCtrl"
                  labelPlacement="floating" placeholder="Enter Recipe Type"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Time Needed (in minutes)" required [(ngModel)]="selectedTimeNeeded"
                  name="timeNeededCtrl" type="number" labelPlacement="floating"
                  placeholder="Enter Time Needed"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Serving Size" required [(ngModel)]="servingSize" name="servingSizeCtrl"
                  labelPlacement="floating" placeholder="Enter Serving Size"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Total Serving" required [(ngModel)]="totalServing" name="totalServingCtrl"
                  labelPlacement="floating" placeholder="Enter Total Serving"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Calories" required [(ngModel)]="calories" name="caloriesCtrl" type="number"
                  labelPlacement="floating" placeholder="Enter Calories"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Protein (in grams)" required [(ngModel)]="protein" name="proteinCtrl" type="number"
                  labelPlacement="floating" placeholder="Enter Protein (in grams)"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Fat (in grams)" required [(ngModel)]="fat" name="fatCtrl" type="number"
                  labelPlacement="floating" placeholder="Enter Fat (in grams)"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Carbohydrates (in grams)" required [(ngModel)]="carbohydrates"
                  name="carbohydratesCtrl" type="number" labelPlacement="floating"
                  placeholder="Enter Carbohydrates (in grams)"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input label="Fiber (in grams)" required [(ngModel)]="fiber" name="fiberCtrl" type="number"
                  labelPlacement="floating" placeholder="Enter Fiber (in grams)"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-textarea rows="10" name="ingredientsCtrl" label="Ingredients" labelPlacement="floating"
                  autoGrow="true" required [(ngModel)]="selectedIngredients" placeholder="Enter Recipe Ingredients...">
                </ion-textarea>
              </ion-item> </ion-col></ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-textarea rows="10" name="howToCtrl" label="Directions" labelPlacement="floating" autoGrow="true"
                  required [(ngModel)]="selectedHowTo" placeholder="Enter Recipe Directions...">
                </ion-textarea>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input name="storageCtrl" label="Storage" autoGrow="true" labelPlacement="floating"
                  [(ngModel)]="storage" placeholder="Storage Info">
                </ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-textarea rows="5" name="descriptionCtrl" label="Description" autoGrow="true"
                  labelPlacement="floating" [(ngModel)]="description" placeholder="Description">
                </ion-textarea>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-textarea rows="5" name="notesCtrl" label="Notes" autoGrow="true" labelPlacement="floating"
                  [(ngModel)]="selectedNotes" placeholder="Additional Info">
                </ion-textarea>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="!isUpdate">
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-checkbox name="notifCtrl" #chkNotif [(ngModel)]="sendNotif">
                  Send Notification
                </ion-checkbox>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="lightmimbo">
                <div>
                  <app-image-picker (photoCaptured)="onPhotoCaptured($event)"></app-image-picker>
                  <br />
                  <small>
                    <ion-text color="success" style="display: block" *ngIf="uploadedImage.length>0">Image Uploaded
                      Successfully</ion-text>
                    <ion-text color="danger" style="display: block"
                      *ngIf="showImageError && uploadedImage.length==0">You need to upload an image to
                      continue</ion-text>
                  </small>
                </div>
              </ion-item>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
              <ion-button type="submit" [disabled]="!f.valid"><ion-icon name="eye-outline" slot="start"></ion-icon>
                Preview Recipe
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </form>
    </ion-content>
    <ion-content *ngIf="isPreviewMode == true" color="lightmimbo">
      <ion-grid>
        <ion-row *ngIf="!isUpdate">
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
            <ion-text *ngIf="sendNotif" color="success" class="notif-label"><ion-icon
                name="checkmark-outline"></ion-icon>A NOTIFICATION WILL
              BE SENT</ion-text>
            <ion-text *ngIf="!sendNotif" color="danger" class="notif-label">
              <ion-icon name="close-outline"></ion-icon>A NOTIFICATION WILL NOT
              BE SENT</ion-text>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <ion-item color="lightmimbo">
              <img [src]="uploadedImage" class="avatar" />
              <div style="padding-bottom: 12px; padding-top: 12px">
                <h1>{{selectedName}}</h1>
                <span class="type">{{selectedType}}</span>
              </div>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-text-center">
            <ion-text class="title">{{selectedName}}</ion-text>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <ion-text class="description">
              {{description}}
            </ion-text>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <div class="recipe-info-box">
              <div class="info-grid">
                <div>
                  <strong>Recipe Type:</strong><br>
                  {{selectedType}} for {{petTypeId == 1 ? 'dogs' : 'cats'}}
                </div>
                <div>
                  <strong>Time Needed:</strong><br>
                  {{selectedTimeNeeded +' mins'}}
                </div>
                <div>
                  <strong>Serving Size:</strong><br>
                  {{servingSize}}
                </div>
                <div>
                  <strong>Total Yield:</strong><br>
                  {{totalServing.replace(' per batch', '').replace(' grams', 'g')}}
                </div>
                <div class="storage-block">
                  <strong>Storage:</strong><br>
                  {{storage}}
                </div>
              </div>

              <hr>

              <div class="jump-link">
                <ion-accordion-group (ionChange)="toggleAccordion($event)"
                  value="{{ isAccordionOpen ? 'first' : undefined }}">
                  <ion-accordion value="first">
                    <ion-item slot="header" color="lightmimbo">
                      <ion-label>{{ isAccordionOpen ? 'Hide Nutritional Facts' : 'View Nutritional Facts'
                        }}</ion-label>
                    </ion-item>
                    <div class="ion-padding light-background" slot="content">
                      <div class="nutrition-label">
                        <h2>Nutrition Facts</h2>
                        <p><strong>Serving size</strong> {{servingSize}}</p>
                        <hr class="thick" />
                        <p class="calories-label"><strong>Amount per serving</strong></p>
                        <p class="calories"><strong>Calories</strong> {{calories}}</p>
                        <hr class="thick" />
                        <div class="itemnutrition">
                          <span><strong>Total Fat</strong></span>
                          <span><strong>{{fat}}g</strong></span>
                        </div>
                        <div class="itemnutrition">
                          <span><strong>Protein</strong></span>
                          <span><strong>{{protein}}g</strong></span>
                        </div>
                        <div class="itemnutrition">
                          <span><strong>Total Carbohydrate</strong></span>
                          <span><strong>{{carbohydrates}}g</strong></span>
                        </div>
                        <div class="itemnutrition">
                          <span><strong>Fiber</strong></span>
                          <span><strong>{{fiber}}g</strong></span>
                        </div>

                        <hr />

                        <p class="footnote">
                          Values are approximate and may vary depending on ingredient brands, preparation methods, and
                          portion sizes.
                        </p>
                      </div>
                    </div>
                  </ion-accordion>
                </ion-accordion-group>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <img [src]="uploadedImage" class="header-image" /><img />
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="prewrap" sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <ion-text class="subtitle">Ingredients</ion-text>
            <div class="ingredients-list">{{selectedIngredients}}</div>
          </ion-col>
        </ion-row>
        <ion-row><ion-col class="prewrap ion-text-center" sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <ion-text><span class="subtitle">Directions</span></ion-text>
            <div class="directions" [innerHTML]="getNewDirections(selectedHowTo)">
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
            <ion-button (click)="AddRecipe()" *ngIf="!isUpdate"><ion-icon name="save-outline"
                slot="start"></ion-icon>Add
              Recipe</ion-button>
            <ion-button (click)="UpdateRecipe()" *ngIf="isUpdate"><ion-icon name="save-outline"
                slot="start"></ion-icon>Update
              Recipe</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ng-template>
</ion-modal>